import {Link} from 'react-router-dom'
import EntityPerformanceChartModal from '../../../../components/EntityPerformanceChartModal/EntityPerformanceChartModal'
import {CustomerReportContext} from '../../context'
import {useState} from 'react'
import {useContext} from 'react'
import { MIN_DATE_RANGE } from '../../utils'

const CustomerTypeReportRow = ({row}: any) => {
  const [showChartModal, setShowChartModal] = useState(false)
  const {
    customerTypeEntityPerformanceChartData,
    isCustomerTypeEntityPerformanceChartDataLoading,
    onCustomerTypeEntityPerformanceChartIdChange,
    onCustomerTypeEntityPerformanceChartViewChange,
    onCustomerTypeEntityPerformanceChartDateRangeChange,
    customerTypeEntityPerformanceChartFilters,
  } = useContext(CustomerReportContext)

  return (
    <>
      <tr>
        <td>{row.customerType}</td>
        <td>
          <Link
            to={{
              pathname: '/analytics/profitability/profitability-report',
              search: `?view=order-report&report_type=discount&customer_type=${row.customerType}`,
            }}
            target='_blank'
            className='text-dark text-decoration-underline'
          >
            {row.orderCount}
          </Link>
        </td>
        <td>{row.discountValue}</td>
        <td>{row.contributedDiscountPercentage}</td>
        <td>
          <div className='d-flex justify-content-end'>
            <span
              onClick={() => setShowChartModal(true)}
              className='w-30px h-30px d-flex justify-content-center align-items-center text-primary cursor-pointer'
            >
              <i className='fas fa-chart-line text-primary'></i>
            </span>
          </div>
        </td>
      </tr>
      {showChartModal && (
        <EntityPerformanceChartModal
          onClose={() => setShowChartModal(false)}
          entityId={row.customerType}
          entityName={`Discount Report - ${row.customerType}`}
          onEntityPerformanceChartIdChange={onCustomerTypeEntityPerformanceChartIdChange}
          onEntityPerformanceChartViewChange={onCustomerTypeEntityPerformanceChartViewChange}
          onEntityPerformanceChartDateRangeChange={
            onCustomerTypeEntityPerformanceChartDateRangeChange
          }
          entityPerformanceChartFilters={customerTypeEntityPerformanceChartFilters}
          isEntityPerformanceChartDataLoading={isCustomerTypeEntityPerformanceChartDataLoading}
          entityPerformanceChartData={customerTypeEntityPerformanceChartData}
          startDate={MIN_DATE_RANGE}
        />
      )}
    </>
  )
}

export default CustomerTypeReportRow
